import { render, staticRenderFns } from "./DialogDirectMember.vue?vue&type=template&id=2c7696cf&scoped=true&"
import script from "./DialogDirectMember.vue?vue&type=script&lang=js&"
export * from "./DialogDirectMember.vue?vue&type=script&lang=js&"
import style0 from "./DialogDirectMember.vue?vue&type=style&index=0&id=2c7696cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7696cf",
  null
  
)

export default component.exports